import { Apis } from '../../app.constants.js';
import APIService from '../../APIService.js';
import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../_states/auth.js';

type LoginActionsType = {
  getLoginView: () => Promise<any>;
};

const LoginActions = (): LoginActionsType => {
  const loggedInUser = useRecoilValue(userInformationAtom);

  const getLoginView = async () => {
    try {
      const getLoginApi = "v0/ui/website/get_login_log/"; 
      const res = await APIService.get(getLoginApi); 
      return res;
    } catch (error) {
      console.error("Error fetching login data:", error); 
      throw error;
    }
  };

  return {
    getLoginView,
  };
};

export { LoginActions };
